export default "/images/framework/TutorialCht.9f976839.svg?9f976839";